import { ChainProvider } from '@occc-app/Chain/chain.context';
import { FooterInfoBannerProvider } from '@occc-app/design-system/layout/AppLayout/footer-info-banner/footer-info-banner.context';
import { FlagsBootstrap } from '@occc-app/flags/flags-bootstrap.context';

import { AuthenticatedRoutes } from './AuthenticatedRoutes';

import AppContextProvider from '../AppContext/AppContextProvider';

export const AuthenticatedApp = () => {
  return (
    <ChainProvider>
      <AppContextProvider>
        <FlagsBootstrap>
          <FooterInfoBannerProvider>
            <AuthenticatedRoutes />
          </FooterInfoBannerProvider>
        </FlagsBootstrap>
      </AppContextProvider>
    </ChainProvider>
  );
};
